import type { FC } from 'react';
import { Control, useController } from 'react-hook-form';
import styled from 'styled-components';

import { FormDataT } from './SubtitlesEditorCard';

const Button = styled.button.attrs({ type: 'button' })<{ $active: boolean }>`
  display: flex;
  width: 31px;
  height: 31px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.purple : theme.colors.gray};

  &:hover {
    border-color: ${({ theme }) => theme.colors.gray};
  }
`;

const Wrap = styled.div`
  flex-shrink: 0;
  display: flex;
  gap: 8px;
`;

interface Props {
  control: Control<FormDataT>;
  index: number;
}

const SubsPositionField: FC<Props> = ({ control, index }) => {
  const {
    field: { value, onChange },
  } = useController<FormDataT, `script.${number}.position`>({
    name: `script.${index}.position`,
    control,
  });

  return (
    <Wrap>
      <Button $active={value === 'bottom'} onClick={() => onChange('bottom')}>
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.74268 14.5C9.02186 14.5 9.27433 14.3856 9.45574 14.2011L13.6924 9.96448C14.0829 9.57396 14.0829 8.94079 13.6924 8.55027C13.3018 8.15974 12.6687 8.15974 12.2781 8.55027L9.74268 11.0857V3.5C9.74268 2.94771 9.29496 2.5 8.74268 2.5C8.19039 2.5 7.74268 2.94771 7.74268 3.5V11.0858L5.20711 8.55027C4.81658 8.15974 4.18342 8.15974 3.79289 8.55027C3.40237 8.94079 3.40237 9.57396 3.79289 9.96448L8.03552 14.2071C8.06077 14.2324 8.08723 14.2561 8.11477 14.2783C8.28641 14.417 8.50485 14.5 8.74268 14.5Z"
            fill="currentColor"
          />
        </svg>
      </Button>
      <Button $active={value === 'top'} onClick={() => onChange('top')}>
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.74268 2.5C9.02186 2.5 9.27433 2.61441 9.45574 2.7989L13.6924 7.03552C14.0829 7.42604 14.0829 8.05921 13.6924 8.44973C13.3018 8.84026 12.6687 8.84026 12.2781 8.44973L9.74268 5.91426V13.5C9.74268 14.0523 9.29496 14.5 8.74268 14.5C8.19039 14.5 7.74268 14.0523 7.74268 13.5V5.91416L5.20711 8.44973C4.81658 8.84026 4.18342 8.84026 3.79289 8.44973C3.40237 8.05921 3.40237 7.42604 3.79289 7.03552L8.03552 2.79289C8.06077 2.76764 8.08723 2.74388 8.11477 2.72167C8.28641 2.58302 8.50485 2.5 8.74268 2.5Z"
            fill="currentColor"
          />
        </svg>
      </Button>
    </Wrap>
  );
};

export default SubsPositionField;
